export default "__VITE_ASSET__9b667a25__"